module.exports = __webpack_public_path__ + "img/innocent.62f768b3.png";